import React from "react";
import { Box, Typography } from "@mui/material";

const ReadOnlyInput = ({
  containerProps = {},
  labelProps = {},
  label,
  value,
}) => {
  return (
    <Box {...containerProps}>
      <Typography
        {...labelProps}
        style={{ margin: "10px 0", textWrap: "nowrap" }}
      >
        {label}
        <span style={{ color: "red", marginLeft: "5px" }}>*</span>
      </Typography>
      <Box
        sx={{
          border: "1px solid lightgrey",
          borderRadius: "30px",
          padding: "16px 14px",
          width: "100%",
        }}
      >
        {value}
      </Box>
    </Box>
  );
};

export default ReadOnlyInput;
